import { SEGMENT_ANONYMOUS_ID_COOKIE_NAME } from '@lib/tracking/consts'
import Cookies from 'universal-cookie'

export function extractSegmentAnonymousIdFromCookie(
  simpleCookieObject: Record<string, string> | null = null,
) {
  const cookies = new Cookies(simpleCookieObject)
  const segmentAnonymousId = cookies.get<string | undefined>(
    SEGMENT_ANONYMOUS_ID_COOKIE_NAME,
  )

  return segmentAnonymousId
}
